import { createSelector } from "reselect";
import { StoreState } from "Store/Reducers";
import { Fields } from "./PropTypes";

const getAllFieldsFromState = ({ fieldmanagement }: any): Fields => fieldmanagement.fields;
export const getAllFields = createSelector(getAllFieldsFromState, (getAllFieldsFromState) => getAllFieldsFromState);

const getAllValuesFromState = ({ fieldmanagement }: any): any => fieldmanagement.values;
export const getAllValues = createSelector(getAllValuesFromState, (getAllValuesFromState) => getAllValuesFromState);

const getAllPredefinedCandidateFieldsFromState = ({ fieldmanagement }: any): any => fieldmanagement.fields.candidate.saved;
export const getAllPredefinedCandidateFields = createSelector(getAllPredefinedCandidateFieldsFromState, (getAllPredefinedCandidateFieldsFromState) => getAllPredefinedCandidateFieldsFromState);



const getAllCandidateFieldsFromState = ({ fieldmanagement }: any): any => fieldmanagement.fields.candidate?.saved;
export const getAllCandidateFields = createSelector(getAllCandidateFieldsFromState, (getAllCandidateFieldsFromState) => getAllCandidateFieldsFromState);

const getAllFieldsByEntityFromState = ({ fieldmanagement }: any, entity: any): any => fieldmanagement.fields[entity]?.saved;
export const getAllFieldsByEntity = createSelector(getAllFieldsByEntityFromState, (getAllFieldsByEntityFromState) => getAllFieldsByEntityFromState);

const getAllActiveFieldsByEntityFromState = ({ fieldmanagement }: any, entity: any): any => fieldmanagement.fields[entity]?.saved.filter((item: any) => item.status != 0);
export const getAllActiveFieldsByEntity = createSelector(getAllActiveFieldsByEntityFromState, (getAllActiveFieldsByEntityFromState) => getAllActiveFieldsByEntityFromState);


const getFieldByIdFromState = ({ fieldmanagement }: any, entity: any, field_id: any): any => {
    const saved = fieldmanagement.fields[entity].saved.find((item: any) => item.id == field_id);
    const unsaved = fieldmanagement.fields[entity].unsaved;
    if (unsaved[field_id]) {
        return {
            ...saved,
            ...unsaved[field_id]
        };
    }

    return saved;
};
export const getFieldById = createSelector(getFieldByIdFromState, (getFieldByIdFromState) => getFieldByIdFromState);

const getAllRelationsFromState = ({ fieldmanagement }: any): any => fieldmanagement.relations;
export const getAllRelations = createSelector(getAllRelationsFromState, (getAllRelationsFromState) => getAllRelationsFromState);







const filterLoop = (dataset, targetDatasets) => {
    if (!dataset.children) return;
    const datasets = dataset.children;

    const filtered = datasets.filter((item: any) => targetDatasets.includes(item.value));
    if (filtered.length == 0) {
        dataset.children = datasets.filter((item: any) => {
            if (!item?.children) return false;
    
            const deepNestedString = JSON.stringify(item.children);
            for (const target in targetDatasets) {
                if (deepNestedString.includes(`"value":${targetDatasets[target]},`)) {
                    filterLoop(item, targetDatasets);
                    return true;
                }
            }

            return false;
        });

        return;
    }

    dataset.children = filtered;
}

const getAllDatasetsOnFilterFromState = ({ fieldmanagement }: any, targetDatasets: any): any => {
    if (!targetDatasets) return fieldmanagement.datasets.entities;

    let datasets = JSON.parse(JSON.stringify(fieldmanagement.datasets.entities));
    datasets = datasets.filter((item: any) => {
        if (!item?.children) return false;

        const deepNestedString = JSON.stringify(item.children);
        for (const target in targetDatasets) {
            if (deepNestedString.includes(`"value":${targetDatasets[target]},`)) {
                filterLoop(item, targetDatasets);
                return true;
            };
        }

        return false;
    });

    return datasets;
}
export const getAllDatasetsOnFilter = createSelector(getAllDatasetsOnFilterFromState, (getAllDatasetsOnFilterFromState) => getAllDatasetsOnFilterFromState);

const fetchDatasets = ({fieldmanagement}: StoreState) => fieldmanagement.datasets;
const fetchKey = (key: number) => key; 
export const getDatasetLabels = createSelector(fetchDatasets, ({labels}) => labels);
export const getDatasetByIds = createSelector(fetchDatasets, ({byId}) => byId);
export const getRootDatasets = createSelector(fetchDatasets, ({ids}) => ids);
export const getAllDatasets = createSelector(fetchDatasets, ({entities}) => entities);
export const getDatasetByKey = createSelector(fetchDatasets, fetchKey, ({entities}, key) => entities.find((item: any) => item.value == key));
export const getDatasetPathById = createSelector(fetchDatasets, ({pathById}) => pathById);

const fetchLayouts = ({fieldmanagement}: StoreState) => fieldmanagement.layouts;
const fetchByEntity = (_:StoreState, entity) => entity;
const fetchCategoryByEntity = (_: StoreState, {entity, category}: any) => ({entity, category});
export const getAllLayouts = createSelector(fetchLayouts, ({entities}) => entities);
export const getUnsavedCategoryById = createSelector(fetchLayouts, fetchCategoryByEntity, ({entities}, {entity, category}) => entities[entity]?.unsaved[category]);
export const getSavedCategoryById = createSelector(fetchLayouts, fetchCategoryByEntity, ({entities}, {entity, category}) => entities[entity]?.saved[category]);
export const getLayoutsByEntity = createSelector(fetchLayouts, fetchByEntity, ({entities}, entity) => entities[entity]?.saved);

export const getAllOverviewFieldsByEntity = createSelector(fetchLayouts, fetchByEntity, ({entities}, entity) => entities[entity]?.saved?.overviewFields);
export const getAllPrimaryFieldsByEntity = createSelector(fetchLayouts, fetchByEntity, ({entities}, entity) => entities[entity]?.saved?.primaryFields);










export const getUsedFieldsByEntityName = createSelector(
    fetchLayouts,
    (_, entity_name) => entity_name,
    ({ fieldsUsedByEntityName }, entity_name) => fieldsUsedByEntityName?.[entity_name]
);

export const getLayoutsByEntityName = createSelector(
    fetchLayouts,
    (_, entity_name) => entity_name,
    ({ entities }, entity_name) => entities?.[entity_name]?.saved
)